'use client';

import { useState } from 'react';
import Image from 'next/image';
import { CustomButton } from '@/shared/ui/atoms';
import { Typography } from '@/shared/ui/atoms';
import ConsultModal from '@/widgets/landing/modals/ui/templates/ConsultModal';
import * as S from './styles';

const HeroSection = () => {
  const baseImageUrl = process.env.NEXT_PUBLIC_BASE_IMAGE_URL;
  const [open, setOpen] = useState(false);

  return (
    <section id="hero-section" className={S.section}>
      <div className={`${S.Wrapper}`}>
        <div className={S.contentWrapper}>
          <div className={S.copyWrapper}>
            <Typography as="h1" className={S.title}>
              요즘 환자는 ‘검색’보다
              <br />
              ‘질문’으로 병원을 선택해요
            </Typography>
            <Typography className={S.description}>
              제로클릭(Zero-Click)시대,
              <br className="md:hidden" />
              AI가 먼저 추천하는 병원이 선택됩니다.
              <br />
              메디컨텐츠 도입 병원이 추천 상단을 선점합니다.
            </Typography>
          </div>
          <CustomButton
            className={S.button}
            onClick={() => {
              setOpen(true);
            }}
          >
            <Typography className={S.buttonText}>메디컨텐츠 상담 신청</Typography>
            <Image src={'/images/icons/arrow-icon.png'} alt="arrow-right" width={24} height={24} className={S.mobileArrow} />
          </CustomButton>
        </div>
        <div className={S.imageWrapper}>
          <Image src={`${baseImageUrl}/medicontents/landing/hero-m.png`} alt="hero-image-mobile" fill sizes="100%" className={S.mobileHeroImage} priority />
          <Image src={`${baseImageUrl}/medicontents/landing/hero.png`} alt="hero-image-desktop" fill sizes={'100%'} objectFit="contain" className={S.desktopHeroImage} priority />
        </div>
      </div>
      <ConsultModal open={open} onClose={() => setOpen(false)} />
    </section>
  );
};

export default HeroSection;
